/*
* Top Nav bar
*/

import * as React from 'react';
import * as _ from 'lodash';

import Auth from '../auth/auth';
import NavUserInfo from './nav-userinfo';
import { AuthConfig } from '../config/authconfiguration';

export default class Nav extends React.Component<any, any> {
  public readonly messagesPathPrefix: string = 'app.nav.';

  public constructor(props: any) {
    super(props);
  }

  public appText(messagePath: string, prependMessagesPathPrefix: boolean = true, tokenValue: string = ''): string {
    // Return branded app text, based on partial intl.messages path token suffix. Auto concat'ed with this.messagesPathPrefix
    let result = '';
    if (!messagePath || !this.messagesPathPrefix || !this.props.intl || !this.props.intl.messages) { return result; }
    const path = prependMessagesPathPrefix ? `${this.messagesPathPrefix}${messagePath}` : messagePath;

    result = _.get(this.props.intl.messages, path);

    if (result === undefined) {
        // console.log(`ERROR: app-component-base.t: Undefined message for token path "${path}".`);
        result = '';
    }

    const re = /{TOKEN_VALUE}/gi;
    result = result.replace(re, tokenValue);

    return result;
  }

  public render() {    
    // App authentication initialization
    const auth = new Auth();
    const authSession = auth.getSession();    

    const authSessionContact = _.get(authSession, AuthConfig.ProfilePaths.userContact, { firstName: '', lastName: '', title: '' });    
    
    const authUser = {
      email: _.get(authSession, AuthConfig.ProfilePaths.userProfileEmail, ''),
      username: auth.getSessionUsername(),
      contact: authSessionContact,
      userFullName: '',
      userObjId: auth.getSessionUserObjectId(),
    };

    const fullName = [_.get(authUser, 'contact.firstName', ''), _.get(authUser, 'contact.lastName')].join(' ').trim();
    let userName = _.get(authUser, 'username', '');
    if (fullName) { userName += ` (${fullName})`; }
    authUser.userFullName = userName;

    return (
      <nav className="navbar navbar-default navbar-static-top m-b-0">
        <div className="navbar-header">          
          <ul className="nav navbar-top-links navbar-right pull-right">            
            <NavUserInfo authUser={authUser} {...this.props} />
          </ul>
        </div>
      </nav>
    );
  }
}



// WEBPACK FOOTER //
// ./src/applayout/nav.tsx